import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
const RequireAuth = lazy(() =>
  import('@/components/auth/RequireAuth').then((m) => ({ default: m.RequireAuth }))
);
const Login = lazy(() => import('./pages/Login'));

// The CommsHubEntry already defines all /comms/* sub-routes
// It uses ModuleLayout which renders AppHeader (logo, tenant selector, module switcher, etc.)
const CommsHubEntry = lazy(() => import('@/communication-hub/CommsHubEntry'));

const PageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense
    fallback={
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    }
  >
    {children}
  </Suspense>
);

export const CommsHubRoutes: React.FC = () => {
  return (
    <Routes>
      {/* ── Auth ─────────────────────────────────────── */}
      <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />

      {/* ── Comms Hub (all /comms/* routes) ──────────── */}
      <Route path="/comms/*" element={
        <RequireAuth>
          <PageWrapper>
            <CommsHubEntry />
          </PageWrapper>
        </RequireAuth>
      } />

      {/* ── Redirects for routes that don't exist in this app ── */}
      <Route path="/admin/*" element={<Navigate to="/comms" replace />} />
      <Route path="/portal/*" element={<Navigate to="/comms" replace />} />
      <Route path="/onboarding/*" element={<Navigate to="/comms" replace />} />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/comms" replace />} />
      <Route path="*" element={<Navigate to="/comms" replace />} />
    </Routes>
  );
};
